import { NotificationListApp } from "notifications/NotificationListTemplate";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const notificationRoute: RouteObject = {
  path: "notification",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: NotificationListApp,
  }]
};